import { render, staticRenderFns } from "./AnnouncementManage.vue?vue&type=template&id=b9098daa&scoped=true"
import script from "./AnnouncementManage.vue?vue&type=script&lang=js"
export * from "./AnnouncementManage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementManage.vue?vue&type=style&index=0&id=b9098daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9098daa",
  null
  
)

export default component.exports